export default __webpack_public_path__ + "static/media/Bathroom.c596911a.jpg";